export default {
  data: () => ({
    Manual: {
      key: 'MANUAL',
      value: 'Manualna'
    },
    Automatic: {
      key: 'AUTOMATIC',
      value: 'Automatyczna'
    },
  }),
  methods: {
    getTransmissionTypes() {
      return [this.Manual, this.Automatic]
    },
    getTransmissionTypeLabel(value) {
      return this.getTransmissionTypes().find((tc) => tc.key === value).value
    },
  }
}
